// -----------------------------------------------------------------------------
// Investmentsummary Filter
// -----------------------------------------------------------------------------
import Isotope from '../../../../node_modules/isotope-layout/dist/isotope.pkgd.min.js';

const $container = $('.js-is-filter');

const init = () => {
  if ($container.length <= 0) {
    return;
  }
  initEventListeners();
};

/**
 * Filter einrichten
 */
const initEventListeners = () => {
  filter();
};


const filter = () => {
  let buttonFilters = {};
  let buttonFilter = '*';
  var kapitalBedarfi2FilterMax = 1000000;
  var ticketsizei2FilterMax = 1000000;
  var iso = $('.investment-summary-results');

  var rangeFilters = {
    'kapitalbedarf': {'min': 0, 'max': kapitalBedarfi2FilterMax},
    'ticketsize': {'min': 0, 'max': ticketsizei2FilterMax}
  };

  let isIsotopeInit = false;
  let counter = 0;
  function initIsotope() {
    if (isIsotopeInit && counter === 0) {
      iso = new Isotope('.investment-summary-results', {
        itemSelector: '.infocus-element',
        layoutMode: 'fitRows'
      });
    }
  }

  // Initialise Sliders
  $('#slider-kapitalbedarf').slider({
    range: true,
    min: 0,
    max: 1000000,
    step: 1000,
    values: [0, 1000000],
    slide: function (event, ui) {
      $('#kapitalbedarf').val(ui.values[0].toLocaleString() + ' € -  ' + ui.values[1].toLocaleString() + '€');
      $('#kapitalmin').val(ui.values[0]);
      $('#kapitalmax').val(ui.values[1]);
    },
    stop: function (event, ui) {
      updateRangeSlider('kapitalbedarf', ui.values[0], ui.values[1]);
    }
  });
  $('#kapitalbedarf').val($('#slider-kapitalbedarf').slider('values', 0).toLocaleString() + '€ - ' + $('#slider-kapitalbedarf').slider('values', 1).toLocaleString() + ' €');

  $('#slider-ticketsize').slider({
    range: true,
    min: 0,
    max: ticketsizei2FilterMax,
    step: 1000,
    values: [0, ticketsizei2FilterMax],
    slide: function (event, ui) {
      $('#ticketsize').val(ui.values[0].toLocaleString() + ' € -  ' + ui.values[1].toLocaleString() + '€');
      $('#ticketsizemin').val(ui.values[0]);
      $('#ticketsizemax').val(ui.values[1]);
    },
    stop: function (event, ui) {
      updateRangeSlider('ticketsize', ui.values[0], ui.values[1]);
    }
  });
  $('#ticketsize').val($('#slider-ticketsize').slider('values', 0).toLocaleString() + '€ - ' + $('#slider-ticketsize').slider('values', 1).toLocaleString() + ' €');

  // bind filter on select change
  $container.find('.js-summary-filter-is select').change(function () {
    var filterGroup = $(this).parents('.button-group ').attr('data-filter-group');
    var selectedItems = [];
    $.each($(this).find('option:selected'), function (key, value) {
      selectedItems.push(value.getAttribute('data-filter'));
    });
    buttonFilters[filterGroup] = selectedItems;
    buttonFilter = getComboFilter(buttonFilters) || '*';

    isIsotopeInit = true;
    initIsotope();
    counter = counter + 1;
    iso.arrange({
      filter: function () {
        var $this = $(this);
        var kapitalbedarf = $this.attr('data-kapitalbedarf');
        var ticketsize = $this.attr('data-ticketsize');
        var isInKapitalbedarfRange = (rangeFilters.kapitalbedarf.min <= kapitalbedarf && rangeFilters.kapitalbedarf.max >= kapitalbedarf);
        var isInTicketsizeRange = (rangeFilters.ticketsize.min <= ticketsize && rangeFilters.ticketsize.max >= ticketsize);
        return $(this).is(buttonFilter) && isInKapitalbedarfRange && isInTicketsizeRange;
      }
    });
  });


  // Filter zurücksetzen
  $container.find('.js-summary-filter-reset-btn').click(function (e) {
    e.preventDefault();
    buttonFilters = {};
    isIsotopeInit = true;
    initIsotope();
    counter = counter + 1;
    iso.arrange({filter: '*'});

    $('#kapitalbedarf').val(0 + ' € -  ' + kapitalBedarfi2FilterMax.toLocaleString() + '€');
    $('#slider-kapitalbedarf').slider('values', [0, kapitalBedarfi2FilterMax]);

    $('#ticketsize').val(0 + ' € -  ' + ticketsizei2FilterMax.toLocaleString() + '€');
    $('#slider-ticketsize').slider('values', [0, ticketsizei2FilterMax]);

    // Alle Select Filter aktivieren
    $('.js-is-filter #filterBranche, .js-is-filter #filterPhase, .js-is-filter #filterStandort').find('option').prop('selected', true).trigger('change');
  });

  // Wenn Range Slider aktiviert wird
  function updateRangeSlider(slider, min, max) {
    var sldmin = +min;
    var sldmax = +max;
    var filterGroup = slider;

    rangeFilters[filterGroup] = {
      min: sldmin || 0,
      max: sldmax || 1000000
    };

    isIsotopeInit = true;
    initIsotope();
    counter = counter + 1;
    iso.arrange({
      filter: function () {
        var $this = $(this);
        var kapitalbedarf = $this.attr('data-kapitalbedarf');
        var ticketsize = $this.attr('data-ticketsize');
        var isInKapitalbedarfRange = (rangeFilters.kapitalbedarf.min <= kapitalbedarf && rangeFilters.kapitalbedarf.max >= kapitalbedarf);
        var isInTicketsizeRange = (rangeFilters.ticketsize.min <= ticketsize && rangeFilters.ticketsize.max >= ticketsize);
        return $(this).is(buttonFilter) && isInKapitalbedarfRange && isInTicketsizeRange;
      }
    });
  }

  // Flatten object by concatting values
  function getComboFilter(filters) {
    var combo = [];
    // eslint-disable-next-line guard-for-in
    for (var prop in filters) {
      var group = filters[prop];
      if (!group.length) {
        // no filters in group, carry on
        continue;
      }
      // add first group
      if (!combo.length) {
        combo = group.slice(0);
        continue;
      }
      // add additional groups
      var nextCombo = [];
      // split group into combo: [ A, B ] & [ 1, 2 ] => [ A1, A2, B1, B2 ]
      for (var i = 0; i < combo.length; i++) {
        for (var j = 0; j < group.length; j++) {
          var item = combo[i] + group[j];
          nextCombo.push(item);
        }
      }
      combo = nextCombo;
    }
    var comboFilter = combo.join(', ');
    return comboFilter;
  }
};

export {
  init
};
